import React from 'react';
import PropTypes from 'prop-types';
import { mapName } from 'helpers/react_select_helpers';
import UserIconList from 'components/user_icon_list';

import AvailableIntegrations from './available_integrations';
import ActiveIntegrations from './active_integrations';

export default class IntegrationsTab extends React.Component {
  static propTypes = {
    availableDatabases: PropTypes.arrayOf(PropTypes.shape({
      members: PropTypes.array.isRequired
    })).isRequired,
    calendarIntegration: PropTypes.object,
    calendars: PropTypes.array,
    clickToCallIntegration: PropTypes.object,
    contactImportReadyAt: PropTypes.string,
    contactIntegration: PropTypes.object,
    contactSyncAccess: PropTypes.bool,
    currentDatabase: PropTypes.object,
    currentUser: PropTypes.object.isRequired,
    googleIntegration: PropTypes.object,
    importCalendar: PropTypes.bool,
    paths: PropTypes.object.isRequired,
    pushContactsToSource: PropTypes.bool.isRequired,
    svnMember: PropTypes.bool,
  };

  state = {
    database: this.props.currentDatabase
  };

  handleDatabaseSelect = (event) => {
    const { availableDatabases } = this.props;
    const selectedId = Number(event.target.value);
    const database = availableDatabases.find(db => db.id === selectedId) || availableDatabases[0];
    this.setState({ database });
  };

  getSelectedDatabase() {
    const { availableDatabases } = this.props;
    const { database } = this.state;
    return database || availableDatabases[0] || null;
  }

  renderDatabaseSelector() {
    const { availableDatabases } = this.props;
    const database = this.getSelectedDatabase();

    if (!database) {
      return (
        <div className="d-flex flex-column mt-2">
          <p className="fw-semibold mb-0">Select Database</p>
          <p className="mb-0">No databases available.</p>
        </div>
      );
    }

    const members = database.members || [];
    const databaseText = members.length === 1 ? 'User' : 'Users';
    const selectedDatabaseId = database.id || '';
    const databaseSelectId = 'integrations-database-select';
    return (
      <div className="d-flex flex-column">
        <label className="form-label" htmlFor={databaseSelectId}>
          Select Database
        </label>
        <div className="row g-3 align-items-center">
          <div className="col-12 col-md-5">
            <select
              className="form-select"
              id={databaseSelectId}
              value={selectedDatabaseId}
              onChange={this.handleDatabaseSelect}
            >
              {availableDatabases.map(db => (
                <option key={db.id} value={db.id}>
                  {mapName(db)}
                </option>
              ))}
            </select>
          </div>
          <div className="col-12 col-md">
            <div className="d-flex flex-wrap align-items-center">
              <span className="small">
                {members.length} {databaseText}
              </span>
              <UserIconList users={members}/>
            </div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { availableDatabases, calendars } = this.props;
    const database = this.getSelectedDatabase();

    return (
      <React.Fragment>
        {this.renderDatabaseSelector()}
        {database ? (
          <div>
            <h5 className="fw-light mt-7 mb-0">{database.name} Integrations</h5>
            <ActiveIntegrations
              {...this.props}
              calendarsForImport={calendars}
              currentDatabase={database}
              databases={availableDatabases}
            />
            <AvailableIntegrations
              {...this.props}
              currentDatabase={database}
              databases={availableDatabases}
            />
          </div>
        ) : null}
      </React.Fragment>
    );
  }
}
